export const BASE_DEFAULT_AUTO_REPLY_MESSAGE =
  'ご回答ありがとうございました。内容に応じてご連絡する場合がございます。';
export const DEFAULT_AUTO_REPLY_MESSAGE =
  'ご回答ありがとうございました。内容に応じてご連絡する場合がございます。\n※本メッセージは自動返信です';
export const DEFAULT_AUTO_REPLY_MESSAGE_WITH_CONTACT_FORM =
  'ご回答ありがとうございました。内容に応じてご連絡する場合がございます。追加の質問があれば下記よりご連絡ください。\n※本メッセージは自動返信です';
export const MAX_COUNT = 100;
